import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import UpgradeCalculator from './UpgradeCalculator';
import PageLayout from './PageLayout';

const CalculatorPage = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const [items, setItems] = useState([]);
  const [costs, setCosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Set document title
  useEffect(() => {
    document.title = `${t('app.title')} - ${t('app.calculatorTitle')}`;
  }, [t, location]);

  // Load data on component mount
  useEffect(() => {
    const loadData = async () => {
      try {
        const baseUrl = window.location.origin;
        const [itemsResponse, costsResponse] = await Promise.all([
          fetch(`${baseUrl}/list.json`),
          fetch(`${baseUrl}/mech_upgrade_costs.json`)
        ]);

        if (!itemsResponse.ok || !costsResponse.ok) {
          throw new Error('Failed to load data files');
        }

        const [itemsData, costsData] = await Promise.all([
          itemsResponse.json(),
          costsResponse.json()
        ]);

        setItems(itemsData);
        setCosts(costsData);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    loadData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-300">{t('loading.message')}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="bg-red-100 dark:bg-red-900 border border-red-400 dark:border-red-600 text-red-700 dark:text-red-300 px-4 py-3 rounded mb-4">
            <strong className="font-bold">{t('error.title')}</strong>
            <span className="block sm:inline"> {error}</span>
          </div>
          <p className="text-gray-600 dark:text-gray-300">{t('error.message')}</p>
        </div>
      </div>
    );
  }

  return (
    <PageLayout 
      title={t('app.title')}
      subtitle={t('app.subtitle')}
      showLastUpdated={true}
    >
      <UpgradeCalculator items={items} costs={costs} />
    </PageLayout>
  );
};

export default CalculatorPage;
